import React, { Fragment } from "react";
import clsx from "clsx";
import { SRR_TO } from "~/pages/SRR/options";
import { useTranslation } from "react-i18next";
import { getFormatDate } from "../../../../libs/getFormatDate";
import { replaceFirstDigit } from "../../../../libs/phoneNumberUtils";
import { nanoid } from "nanoid";

import s from "./TableRow.less";
import { format } from "date-fns";

const renderTableRow = (rowValues) => {
  return (
    <tr className={clsx(s.row_tr, s.row_td)}>
      {rowValues.map((value) => (
        <td key={nanoid()} className={s.tdTO}>
          {value}
        </td>
      ))}
    </tr>
  );
};

interface IProps {
  options: string[];
  nameChildren?: string[];
  arrTableRowsPeriod?: string[];
  groupNameSrr?: string;
  type: string;
  btnEdit?: boolean;
  btnView?: boolean;
  btnVersion?: boolean;
  btnDel?: boolean;
  searchTextForSelect_ONLY_SRR?: string;
  rowValuesDecorator?: (
    value: any,
    optionName: string,
    dataObject?: any
  ) => any;
  item;
}

const SRRTableRow: React.FC<IProps> = ({
  options = [],
  nameChildren = [],
  groupNameSrr = "",
  arrTableRowsPeriod = [],
  item = {},
  rowValuesDecorator,
  searchTextForSelect_ONLY_SRR,
}) => {
  const { t } = useTranslation();

  const arrTO = [
    "TO0",
    "TO1",
    "TO2",
    "TO3",
    "TO4",
    "TO5",
    "TO6",
    "TO7",
    "TO8",
    "GO1",
    "GO2",
    "GO3",
    "NoWarranty",
    ...arrTableRowsPeriod,
  ];

  // switch (group["group"]) {
  //   case "dealer":
  //     optionsTable = dealerArr.map((el) => row[el]);
  //     break;
  //   case "city":
  //     optionsTable = cityArr.map((el) => row[el]);
  //
  //     break;
  //   case "fo":
  //     optionsTable = foArr.map((el) => row[el]);
  //
  //     break;
  //   case "region":
  //     optionsTable = regionArr.map((el) => row[el]);
  //     break;
  // }

  let sumServiceCount = 0;
  let sumSaleCount = 0;
  let sumTarget = 0;
  let sumPercent = 0;
  let sumPercentTarget = 0;
  let sumRegisteredCity = 0;
  let sumRegisteredRegion = 0;

  const toCheck = (to = {} as any) => {
    let itemTO = item[to] || {};
    if (typeof to === "object" && !Array.isArray(to)) itemTO = to;
    const rowData = [];

    switch (searchTextForSelect_ONLY_SRR) {
      // case "ReportReturnSRR3ByDealer":
      // case "ReportReturnSRR5ByDealer":
      //   if (to) {
      //     if (typeof to === "object") {
      //       let serviceCount = to?.cars.length;
      //       let percent = 0;
      //       if (to.saleCount > 0 && serviceCount > 0) {
      //         percent = (serviceCount / to.saleCount) * 100;
      //       }
      //       sumServiceCount = Number(sumServiceCount) + Number(serviceCount);
      //       sumSaleCount = Number(sumSaleCount) + Number(to.saleCount);
      //
      //       rowData.push(to.saleCount, serviceCount, percent.toFixed(2));
      //     } else {
      //       let sumPercents = 0;
      //       if (sumServiceCount > 0 && sumSaleCount > 0) {
      //         sumPercents = (sumServiceCount / sumSaleCount) * 100;
      //       }
      //       rowData.push(sumSaleCount, sumServiceCount, sumPercents.toFixed(2));
      //     }
      //   } else {
      //     rowData.push(0, 0, 0);
      //   }
      //   break;

      case "ReportReturnSRR3ByPeriod":
      case "ReportReturnSRR5ByPeriod":
        let serviceCounte = itemTO?.serviceCount;

        let percente = 0;
        if (itemTO?.saleCount > 0 && serviceCounte > 0) {
          percente = (serviceCounte / itemTO?.saleCount) * 100;
        }
        rowData.push(itemTO?.saleCount, serviceCounte, percente.toFixed(2));
        break;
      case "ReportReturnCarServiceDynamics":
        const toPercent = (to / item.AllTO) * 100;
        rowData.push(
          to,
          `${toPercent !== 0 && !isNaN(toPercent) ? toPercent.toFixed(2) : 0}%`
        );
        break;
      case "TOReturnCarForServiceByPeriodConsolidated":
        const arrTOName = [
          "TO0",
          "TO1",
          "TO2",
          "TO3",
          "TO4",
          "TO5",
          "TO6",
          "TO7",
          "TO8",
        ];
        if (to) {
          if (item[to]) {
            if (arrTOName.includes(to)) {
              rowData.push(
                item[to].name,
                item[to].inn,
                item[to].dateVisit
                  ? format(new Date(item[to].dateVisit), "dd MM yyyy")
                  : "-",
                item[to].countDay
              );
            }

            if (to === "cars") {
              rowData.push(
                item[to].vin,
                item[to].eqFamilyCode,
                item[to].eqNumber,
                item[to].eqVariant,
                item[to].familyCar,
                item[to].dateSales
                  ? format(new Date(item[to].dateSales), "dd MM yyyy")
                  : "-"
              );
            }

            if (to === "client") {
              rowData.push(item[to].name, item[to].phone, item[to].email);
            }

            if (to === "dealer") {
              rowData.push(item[to].name, item[to].inn, item[to].city);
            }
          } else {
            if (arrTOName.includes(to)) {
              rowData.push(0, 0, 0, 0);
            }

            if (to === "cars") {
              rowData.push("-", "-", "-", "-", "-", "-");
            }

            if (to === "client" && to === "dealer") {
              rowData.push("-", "-", "-");
            }
          }
        }

        break;

      case "ReportReturnCarAverageDailyMileageByMonth":
        let AverageDailyMileage = 0;
        if (itemTO) {
          if (itemTO.mileage > 0 && itemTO.averageDay > 0) {
            AverageDailyMileage = itemTO.mileage / itemTO.averageDay;
          }

          rowData.push(
            itemTO.countCar ? itemTO.countCar : 0,
            itemTO.averageDay ? itemTO.averageDay : 0,
            itemTO.mileage ? itemTO.mileage : 0,
            AverageDailyMileage ? AverageDailyMileage.toFixed(2) : 0
          );
        } else {
          rowData.push(0, 0, 0, AverageDailyMileage);
        }
        break;
      case "ReportReturnSRR3ByVIN":
      case "ReportReturnSRR5ByVIN":
        const chekDealerName = (el) => (el ? el : "-");
        const chekDateVisit = (el) =>
          el ? format(new Date(el), "dd MM yyyy") : "-";

        rowData.push(
          chekDealerName(itemTO.dealerName),
          chekDateVisit(itemTO.dateVisit)
        );
        break;
      case "ReportReturnClientsWithoutService":
        rowData.push(item?.countCar, item?.withoutServices, item?.percent);
        break;

      case "ReportReturnCarForServiceGIBDDByMonth":
      case "ReportReturnCarForServiceGIBDDByPeriod":
        if (itemTO) {
          let serviceCount = itemTO?.cars?.length;
          let countRegisteredCity = itemTO?.carsCityGIBDD || [];
          let countRegisteredRegion = itemTO?.carsRegionGIBDD || [];
          let countRegisteredAllRegion = itemTO?.carsAllRegionGIBDD || 0;

          let percentSale = 0;
          let percentSaleCity = 0;
          let percentSaleRegion = 0;
          let percentSaleAllRegion = 0;
          if (itemTO.saleCount > 0 && serviceCount > 0) {
            percentSale = (serviceCount / itemTO.saleCount) * 100;
          }
          if (itemTO.saleCount > 0 && countRegisteredCity.length > 0) {
            percentSaleCity =
              (countRegisteredCity.length / itemTO.saleCount) * 100;
          }
          if (itemTO.saleCount > 0 && countRegisteredRegion.length > 0) {
            percentSaleRegion =
              (countRegisteredRegion.length / itemTO.saleCount) * 100;
          }
          if (itemTO.saleCount > 0 && countRegisteredAllRegion > 0) {
            percentSaleAllRegion =
              (countRegisteredAllRegion / itemTO.saleCount) * 100;
          }
          rowData.push(
            itemTO.saleCount,
            countRegisteredCity.length,
            countRegisteredRegion.length,
            countRegisteredAllRegion || "",
            serviceCount,
            percentSale.toFixed(2),
            percentSaleCity.toFixed(2),
            percentSaleRegion.toFixed(2),
            percentSaleAllRegion.toFixed(2) || ""
          );
        } else {
          rowData.push(0, 0, 0, "", 0, 0, 0, 0, "");
        }
        break;
      case "ReportReturnCarForeignForServiceGIBDDByMonth":
      case "ReportReturnCarForeignForServiceGIBDDByPeriod":
        if (itemTO) {
          const toCarsForeign = itemTO.carsForeign || [];

          let serviceCountGeneral = itemTO.cars?.length + toCarsForeign.length;
          let serviceCountMine = itemTO.cars?.length;
          let serviceCountStranger = toCarsForeign.length;
          let countRegisteredAllRegion = itemTO.carsAllRegionGIBDD || 0;

          let percentMine = 0;
          let percentStranger = 0;
          let percentSaleAllRegion = 0;

          if (itemTO.saleCount > 0 && serviceCountMine > 0) {
            percentMine = (serviceCountMine / itemTO.saleCount) * 100;
          }
          if (itemTO.saleCount > 0 && serviceCountStranger > 0) {
            percentStranger = (serviceCountStranger / itemTO.saleCount) * 100;
          }

          let countRegisteredCity = itemTO.carsCityGIBDD || [];
          let countRegisteredRegion = itemTO.carsRegionGIBDD || [];
          // let countRegisteredAllRegion = itemTO.cars.length || [];

          let percentSale = 0;
          let percentSaleCity = 0;
          let percentSaleRegion = 0;
          // let percentSaleAllRegion = 0;
          if (itemTO.saleCount > 0 && serviceCountGeneral > 0) {
            percentSale = (serviceCountGeneral / itemTO.saleCount) * 100;
          }
          if (itemTO.saleCount > 0 && countRegisteredCity.length > 0) {
            percentSaleCity =
              (countRegisteredCity.length / itemTO.saleCount) * 100;
          }
          if (itemTO.saleCount > 0 && countRegisteredRegion.length > 0) {
            percentSaleRegion =
              (countRegisteredRegion.length / itemTO.saleCount) * 100;
          }
          if (itemTO.saleCount > 0 && countRegisteredAllRegion > 0) {
            percentSaleAllRegion =
              (countRegisteredAllRegion / to.saleCount) * 100;
          }
          rowData.push(
            itemTO.saleCount,
            countRegisteredCity.length,
            countRegisteredRegion.length,
            // countRegisteredAllRegion || "",
            serviceCountGeneral,
            percentSale.toFixed(2),
            percentSaleCity.toFixed(2),
            percentSaleRegion.toFixed(2),
            percentSaleAllRegion.toFixed(2) || "",
            serviceCountMine,
            percentMine.toFixed(2),
            serviceCountStranger,
            percentStranger.toFixed(2)
          );
        } else {
          rowData.push(0, 0, 0, "", 0, 0, 0, 0, "");
        }
        break;
      case "ReportReturnSRR3GIBDDByDealer":
      case "ReportReturnSRR5GIBDDByDealer":
        console.log(1);
        if (itemTO) {
          if (typeof itemTO === "object") {
            let serviceCount = itemTO.cars?.length;
            let countRegisteredCity = itemTO.carsCityGIBDD || [];
            let countRegisteredRegion = itemTO.carsRegionGIBDD || [];

            let percentSale = 0;
            let percentSaleCity = 0;
            let percentSaleRegion = 0;

            if (itemTO.saleCount > 0 && serviceCount > 0) {
              percentSale = (serviceCount / itemTO.saleCount) * 100;
            }
            if (itemTO.saleCount > 0 && countRegisteredCity.length > 0) {
              percentSaleCity =
                (countRegisteredCity.length / itemTO.saleCount) * 100;
            }
            if (itemTO.saleCount > 0 && countRegisteredRegion.length > 0) {
              percentSaleRegion =
                (countRegisteredRegion.length / itemTO.saleCount) * 100;
            }

            sumServiceCount = Number(sumServiceCount) + Number(serviceCount);
            sumSaleCount = Number(sumSaleCount) + Number(itemTO.saleCount);
            sumRegisteredRegion =
              Number(sumRegisteredRegion) +
              Number(countRegisteredRegion.length);
            sumRegisteredCity =
              Number(sumRegisteredCity) + Number(countRegisteredCity.length);

            rowData.push(
              itemTO.saleCount,
              countRegisteredCity.length,
              countRegisteredRegion.length,
              serviceCount,
              percentSale.toFixed(2),
              percentSaleCity.toFixed(2),
              percentSaleRegion.toFixed(2)
            );
          } else {
            let sumPercentSale = 0;
            let sumPercentSaleCity = 0;
            let sumPercentSaleRegion = 0;

            if (sumSaleCount > 0 && sumServiceCount > 0) {
              sumPercentSale = (sumServiceCount / itemTO.saleCount) * 100;
            }
            if (sumSaleCount > 0 && sumRegisteredCity > 0) {
              sumPercentSaleCity = (sumRegisteredCity / itemTO.saleCount) * 100;
            }
            if (sumSaleCount > 0 && sumRegisteredRegion > 0) {
              sumPercentSaleRegion =
                (sumRegisteredRegion / itemTO.saleCount) * 100;
            }

            rowData.push(
              sumSaleCount,
              sumRegisteredCity,
              sumRegisteredRegion,
              sumServiceCount,
              sumPercentSale.toFixed(2),
              sumPercentSaleCity.toFixed(2),
              sumPercentSaleRegion.toFixed(2)
            );
          }
        } else {
          rowData.push(0, 0, 0, 0, 0, 0, 0);
        }
        break;

      case "ReportReturnSRR3GIBDDByPeriod":
      case "ReportReturnSRR5GIBDDByPeriod":
        if (itemTO) {
          let serviceCount = itemTO?.serviceCount;
          let countRegisteredCity = itemTO?.carsCityGIBDD;
          let countRegisteredRegion = itemTO?.carsRegionGIBDD;
          let countRegisteredAllRegion = itemTO?.carsAllRegionGIBDD;
          let saleCount = itemTO?.saleCount;

          let percentSale = 0;
          let percentSaleCity = 0;
          let percentSaleRegion = 0;
          let percentSaleAllRegion = 0;
          if (saleCount > 0 && serviceCount > 0) {
            percentSale = (serviceCount / saleCount) * 100;
          }
          if (saleCount > 0 && countRegisteredCity.length > 0) {
            percentSaleCity = (countRegisteredCity.length / saleCount) * 100;
          }
          if (saleCount > 0 && countRegisteredRegion.length > 0) {
            percentSaleRegion =
              (countRegisteredRegion.length / saleCount) * 100;
          }
          if (saleCount > 0 && countRegisteredAllRegion > 0) {
            percentSaleAllRegion = (countRegisteredAllRegion / saleCount) * 100;
          }
          rowData.push(
            saleCount,
            countRegisteredCity,
            countRegisteredRegion,
            countRegisteredAllRegion,
            serviceCount,
            percentSale.toFixed(2),
            percentSaleCity.toFixed(2),
            percentSaleRegion.toFixed(2),
            percentSaleAllRegion.toFixed(2)
          );
        } else {
          rowData.push(0, 0, 0, 0, 0, 0, 0, 0, 0);
        }
        break;
    }
    return rowData;
  };

  const renderRowsByParams = () => {
    const rowData = [];
    const {
      dealer,
      City,
      Region,
      FO,
      Country,
      moneyTotal,
      carsTotal,
      averageReceipt,
    } = item;
    if (
      !!dealer &&
      groupNameSrr === "dealer" &&
      (searchTextForSelect_ONLY_SRR === "ReportReturnAverageReceiptAKC" ||
        searchTextForSelect_ONLY_SRR === "ReportAverageReceiptTO")
    ) {
      rowData.push(
        dealer?.DealerName ? dealer?.DealerName : "-",
        dealer?.INN ? dealer?.INN : "-",
        dealer?.code ? dealer?.code : "-"
      );
    }
    if (
      !!City &&
      (groupNameSrr === "city" || groupNameSrr === "dealer") &&
      (searchTextForSelect_ONLY_SRR === "ReportReturnAverageReceiptAKC" ||
        searchTextForSelect_ONLY_SRR === "ReportAverageReceiptTO")
    ) {
      rowData.push(City ? City : "-");
    }
    if (
      !!Region &&
      (groupNameSrr === "region" ||
        groupNameSrr === "city" ||
        groupNameSrr === "dealer") &&
      (searchTextForSelect_ONLY_SRR === "ReportReturnAverageReceiptAKC" ||
        searchTextForSelect_ONLY_SRR === "ReportAverageReceiptTO")
    ) {
      rowData.push(Region ? Region : "-");
    }
    if (
      !!FO &&
      (groupNameSrr === "FO" ||
        groupNameSrr === "city" ||
        groupNameSrr === "dealer" ||
        groupNameSrr === "region") &&
      (searchTextForSelect_ONLY_SRR === "ReportReturnAverageReceiptAKC" ||
        searchTextForSelect_ONLY_SRR === "ReportAverageReceiptTO")
    ) {
      rowData.push(FO ? FO : "-");
    }
    if (
      !!Country &&
      groupNameSrr === "country" &&
      (searchTextForSelect_ONLY_SRR === "ReportReturnAverageReceiptAKC" ||
        searchTextForSelect_ONLY_SRR === "ReportAverageReceiptTO")
    ) {
      rowData.push(Country ? Country : "-");
    }

    switch (searchTextForSelect_ONLY_SRR) {
      case "ReportReturnAverageReceiptAKC":
        rowData.push(moneyTotal, carsTotal, averageReceipt);
        break;
      case "ReportAverageReceiptTO":
        rowData.push(carsTotal, moneyTotal, averageReceipt);
        break;
      case "InvitationOfClientsForMaintenance":
        const {
          car,
          fio,
          phone,
          email,
          agree,
          dateSales,
          maxDateVisit,
          avgRun,
          lastComment,
          prevTODealer,
          prevToText,
          nextToDate,
        } = item;

        const currentTos = SRR_TO.filter((item) =>
          options.includes(item.label)
        );
        const numberOfTOs = currentTos.length;

        rowData.push(
          car,
          fio,
          replaceFirstDigit(phone),
          email,
          agree ? "Да" : "Нет",
          getFormatDate(dateSales, true),
          getFormatDate(maxDateVisit, true),
          avgRun,
          lastComment,
          prevTODealer,
          prevToText,
          nextToDate
        );
        break;
    }
    return rowData;
  };

  const shouldRenderCustomRow = () => {
    const customRows = [
      "InvitationOfClientsForMaintenance",
      "ReportAverageReceiptTO",
      "ReportReturnAverageReceiptAKC",
    ];

    return customRows.includes(searchTextForSelect_ONLY_SRR);
  };

  const renderDefaultValue = (optionName: string) => {
    return (
      <td
        style={{ maxWidth: 100, overflow: "hidden" }}
        className={s.tdTO}
        data-option_name={optionName}
      >
        <div>
          <span className={s.cont}>
            {rowValuesDecorator(
              optionName === "modelName"
                ? item["model"]?.name
                : item[optionName],
              optionName,
              item
            )}
          </span>
        </div>
      </td>
    );
  };

  const renderTOValue = (optionName: string) => {
    const hasPeriod =
      arrTableRowsPeriod.length && arrTableRowsPeriod.includes(optionName);
    let targetItem = hasPeriod ? item[optionName] : optionName;
    if (searchTextForSelect_ONLY_SRR === "ReportReturnCarServiceDynamics")
      targetItem = item[optionName];

    return toCheck(targetItem).map((value) => {
      return (
        <td key={nanoid()} className={s.tdTO}>
          {value}
        </td>
      );
    });
  };

  return (
    <>
      {shouldRenderCustomRow() ? (
        <tr className={clsx(s.row_tr, s.row_td)}>
          {renderRowsByParams().map((value, idx) => (
            <td key={value + idx} className={s.tdTO}>
              {value || ""}
            </td>
          ))}
        </tr>
      ) : (
        <tr className={clsx(s.row_tr, s.row_td)}>
          {options?.map((optionName) => {
            return (
              <Fragment key={nanoid()}>
                {!arrTO.includes(optionName)
                  ? renderDefaultValue(optionName)
                  : renderTOValue(optionName)}
              </Fragment>
            );
          })}
        </tr>
      )}
    </>
  );
};
export default SRRTableRow;
